import {
  LIST_IDENTITY_TYPE_SUMMARY_REQUEST,
  LIST_IDENTITY_TYPE_SUMMARY_SUCCESS,
  LIST_IDENTITY_TYPE_SUMMARY_FAIL,
  LIST_IDENTITY_TYPE_SUMMARY_RESET,
  LIST_IDENTITY_TYPE_REQUEST,
  LIST_IDENTITY_TYPE_SUCCESS,
  LIST_IDENTITY_TYPE_FAIL,
  LIST_IDENTITY_TYPE_RESET,
  CREATE_IDENTITY_TYPE_REQUEST,
  CREATE_IDENTITY_TYPE_SUCCESS,
  CREATE_IDENTITY_TYPE_FAIL,
  DETAIL_IDENTITY_TYPE_REQUEST,
  DETAIL_IDENTITY_TYPE_SUCCESS,
  DETAIL_IDENTITY_TYPE_FAIL,
  UPDATE_IDENTITY_TYPE_REQUEST,
  UPDATE_IDENTITY_TYPE_SUCCESS,
  UPDATE_IDENTITY_TYPE_FAIL,
  DELETE_IDENTITY_TYPE_REQUEST,
  DELETE_IDENTITY_TYPE_SUCCESS,
  DELETE_IDENTITY_TYPE_FAIL
} from '../../constants/identity-types'

const initialState = {
  loading: false,
  identityTypes: [],
  identityType: {},
  identityTypesSummary: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const identityTypeListReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_IDENTITY_TYPE_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_IDENTITY_TYPE_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        identityTypesSummary: action.payload
      }
    case LIST_IDENTITY_TYPE_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_IDENTITY_TYPE_SUMMARY_RESET:
      return { ...state, loading: false, identityTypesSummary: [] }
    case LIST_IDENTITY_TYPE_REQUEST:
      return { ...state, loading: true }
    case LIST_IDENTITY_TYPE_SUCCESS:
      return { ...state, loading: false, identityTypes: action.payload, pageable: action.pageable }
    case LIST_IDENTITY_TYPE_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_IDENTITY_TYPE_RESET:
      return { ...state, loading: false, identityTypes: [] }
    case CREATE_IDENTITY_TYPE_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_IDENTITY_TYPE_SUCCESS:
      return { ...state, loadingCreate: false, identityTypes: [...state.identityTypes, action.payload] }
    case CREATE_IDENTITY_TYPE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_IDENTITY_TYPE_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_IDENTITY_TYPE_SUCCESS:
      return { ...state, loadingDetail: false, identityType: action?.payload }
    case DETAIL_IDENTITY_TYPE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_IDENTITY_TYPE_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_IDENTITY_TYPE_SUCCESS:
      const identityTypePayload = action.payload
      const identityTypeIndex = state.identityTypes.findIndex(identityType => identityType.id === identityTypePayload.id)

      const identityTypesUpdate = [...state.identityTypes]
      identityTypesUpdate[identityTypeIndex] = identityTypePayload

      return { ...state, loadingUpdate: false, identityTypes: identityTypesUpdate }
    case UPDATE_IDENTITY_TYPE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_IDENTITY_TYPE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_IDENTITY_TYPE_SUCCESS:
      const identityTypeId = action.payload

      const identityTypeIndexDelete = state.identityTypes.findIndex(identityType => identityType.id === identityTypeId)
      const identityTypesDelete = [...state.identityTypes]

      identityTypesDelete.splice(identityTypeIndexDelete, 1)

      return { ...state, loadingDelete: false, identityTypes: identityTypesDelete }
    case DELETE_IDENTITY_TYPE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    default:
      return state
  }
}

export default identityTypeListReducer